export const CLINICIAN_APP_STORE_URL =
  process.env.REACT_APP_CLINICIAN_APP_STORE_URL ||
  "https://apps.apple.com/app/talaqah-specialists/id6465991161";

export const CLINICIAN_PLAY_STORE_URL =
  process.env.REACT_APP_CLINICIAN_PLAY_STORE_URL ||
  "https://play.google.com/store/apps/details?id=com.talaqah.clinician.app";

export const ONBOARDING_DAYS = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
] as const;
